<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="128.000000pt"
    height="128.000000pt"
    viewBox="0 0 128.000000 128.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M123 1201 c-134 -61 -133 -261 1 -322 36 -17 69 -19 298 -19 178 0
259 3 264 11 14 23 -25 29 -193 29 l-172 0 24 36 c45 66 45 142 0 208 l-24 36
439 0 440 0 0 -140 0 -140 -232 -2 c-199 -3 -233 -5 -233 -18 0 -13 34 -15
250 -15 l250 0 0 175 0 175 -535 2 c-507 3 -537 2 -577 -16z m154 -41 c87 -52
83 -198 -6 -245 -98 -50 -211 16 -211 123 0 85 56 142 140 142 27 0 58 -8 77
-20z"
      />
      <path
        d="M165 1130 c-4 -7 2 -14 14 -17 19 -5 21 -12 21 -90 0 -75 2 -84 18
-81 15 3 17 16 17 98 l0 95 -32 3 c-17 2 -34 -2 -38 -8z"
      />
      <path
        d="M910 795 c-23 -25 -25 -43 -6 -70 7 -11 16 -38 19 -59 12 -78 84
-119 156 -90 51 20 71 55 71 121 0 86 -44 121 -153 120 -55 -1 -71 -5 -87 -22z
m30 -30 c-7 -9 -15 -13 -18 -10 -3 2 1 11 8 20 7 9 15 13 18 10 3 -2 -1 -11
-8 -20z m139 10 c26 -13 41 -33 41 -56 0 -15 -19 -10 -40 11 -19 19 -20 19
-52 1 -18 -11 -43 -22 -55 -26 -33 -9 -30 20 6 56 33 32 58 36 100 14z m41
-116 c0 -17 -35 -53 -63 -62 -43 -16 -130 52 -96 74 8 5 21 9 29 9 8 0 26 7
38 14 20 11 29 10 58 -3 18 -9 33 -23 34 -32z"
      />
      <path
        d="M125 791 c-48 -22 -69 -44 -90 -94 -21 -50 -19 -93 6 -145 42 -86
148 -124 233 -82 38 18 65 22 149 23 88 2 102 4 105 20 3 15 -6 17 -87 17
l-90 0 15 35 c18 44 18 86 0 130 l-15 35 215 0 214 0 0 -100 0 -100 -101 0
c-90 0 -100 -2 -97 -17 3 -15 17 -18 98 -21 151 -5 141 -15 138 141 l-3 132
-255 5 c-215 4 -261 8 -292 23 -48 22 -92 21 -143 -2z m152 -41 c40 -24 63
-67 63 -120 0 -82 -58 -140 -141 -140 -78 0 -139 60 -139 138 0 85 56 142 140
142 27 0 58 -8 77 -20z"
      />
      <path
        d="M154 715 c-24 -24 -25 -45 -2 -45 6 0 16 7 23 17 15 20 45 11 45 -13
0 -10 -18 -41 -40 -70 -22 -29 -40 -58 -40 -64 0 -7 22 -10 63 -8 65 3 85 21
30 26 -18 2 -33 5 -33 7 0 2 14 26 30 52 37 58 37 76 4 102 -35 27 -50 26 -80
-4z"
      />
      <path
        d="M1087 563 c-14 -13 -6 -21 39 -38 69 -26 76 1 7 30 -41 17 -38 17
-46 8z"
      />
      <path
        d="M905 537 c-61 -34 -88 -92 -93 -198 -4 -89 6 -129 33 -129 8 0 17
-15 21 -36 4 -19 13 -38 21 -41 21 -8 23 0 11 40 -11 35 -10 38 36 92 26 30
54 55 62 55 7 0 21 11 30 25 15 23 15 27 -1 51 -14 22 -22 25 -48 20 -35 -7
-74 -32 -91 -59 -16 -25 2 -33 27 -10 24 23 60 43 75 43 6 0 12 -7 16 -15 3
-10 -7 -21 -32 -35 -20 -10 -50 -37 -67 -60 -40 -56 -59 -50 -63 20 -8 124 34
204 118 229 22 6 40 16 40 21 0 18 -54 10 -95 -13z"
      />
      <path
        d="M1196 503 c-11 -11 -6 -23 9 -23 8 0 15 4 15 9 0 13 -16 22 -24 14z"
      />
      <path
        d="M1124 455 c-3 -8 4 -28 15 -44 26 -35 26 -49 4 -74 -17 -18 -17 -19
0 -32 36 -26 13 -116 -35 -136 -43 -18 -58 -36 -58 -71 0 -29 -2 -30 -32 -24
-18 3 -40 7 -48 8 -25 5 -24 -16 1 -30 31 -17 126 -8 176 15 50 24 99 90 112
153 22 103 7 240 -26 240 -12 0 -13 -6 -7 -27 5 -16 9 -68 9 -118 0 -76 -4
-98 -25 -139 -27 -54 -61 -84 -100 -88 -41 -5 -31 29 15 55 50 28 64 65 64
170 1 67 -2 83 -25 117 -30 45 -32 46 -40 25z"
      />
      <path
        d="M125 383 c-46 -24 -66 -45 -86 -88 -24 -53 -24 -99 2 -153 53 -108
198 -132 283 -47 31 31 41 34 98 37 48 2 63 7 63 18 0 11 -14 16 -55 18 l-55
3 1 52 2 52 137 0 137 0 2 -52 1 -52 -60 -3 c-45 -2 -60 -7 -60 -18 0 -12 15
-15 75 -15 l75 0 3 88 3 87 -166 0 -166 0 -25 29 c-48 58 -145 78 -209 44z
m132 -33 c138 -62 94 -270 -57 -270 -151 0 -195 208 -57 270 23 11 49 20 57
20 8 0 34 -9 57 -20z"
      />
      <path
        d="M160 310 c-24 -24 -26 -50 -5 -50 9 0 18 7 21 15 8 19 40 20 47 0 4
-8 -5 -23 -21 -35 -15 -12 -22 -23 -16 -26 6 -3 20 -11 30 -19 18 -13 18 -14
1 -32 -18 -17 -19 -17 -41 10 -23 28 -36 27 -36 -3 0 -43 73 -66 102 -32 24
26 22 148 -3 173 -25 25 -54 24 -79 -1z"
      />
      <path
        d="M973 278 c-29 -37 -11 -89 42 -124 26 -17 27 -16 61 17 69 67 51 119
-41 119 -30 0 -57 -5 -62 -12z m114 -34 c2 -7 -7 -25 -21 -40 l-24 -29 -26 24
c-42 39 -35 59 21 57 25 0 48 -6 50 -12z"
      />
      <path d="M907 114 c-8 -8 1 -24 14 -24 5 0 9 7 9 15 0 15 -12 20 -23 9z" />
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
